

import ListOffers from './ListOffers';

export default { ListOffers };



// WEBPACK FOOTER //
// ./src/components/pages/admin/offers/index.js